import Styled from 'styled-components';
import {Modal, Button} from 'react-bootstrap';

export const ModalContainer = Styled(Modal)`

`;

export const ModalHeader = Styled(Modal.Header)`
  background-color: ${props => props.theme.bg.modal};
  color: ${props => props.theme.text.color.light};
  border-bottom: 1px solid ${props => props.theme.color.modalBorder};
  button {
    color: white;
    text-shadow: none;
    font-weight: 400;
    font-size: 2rem;
    &:hover {
      color: white;
    }
  }
`;

export const ModalTitle = Styled(Modal.Title)`
  
`;

export const ModalBody = Styled(Modal.Body)`
  background-color: ${props => props.theme.bg.modal};
  color: ${props => props.theme.text.color.panel};
  border: none;
`;

export const ModalFooter = Styled(Modal.Footer)`
  background-color: ${props => props.theme.bg.modal};
  color: ${props => props.theme.text.color.panel};
  border-top: 1px solid ${props => props.theme.color.modalBorder};
  display: flex;
  justify-content: space-between;
`;

export const CloseButton = Styled(Button)`
  &:hover {
    opacity: 0.9;
  }
`;

export const SaveButton = Styled(Button)`
  opacity: ${props => props.disabled ? 0.3 : 1};
`;


